//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  selectParentList //查询职称三级联动
} from "@/assets/js/api";
export default {
  name: "common-titles",
  props: ["titlesId"],
  data() {
    return {
      nowLevel: 0, //当前正在选择的职称级别
      chooseTitlesArr: [
        //当前选择的职称数组
        {
          id: null,
          name: "请选择"
        }
      ],
      allTitles: null, //所有职称
      titlesArr: {}, //职称数组
      nowIndex: null, //当前选择的下标
      titlesArrList: [{}, {}, {}], //不同级别的职称数组
      indexList: [null, null, null] //不同级别选择的职称下标
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    //初始化
    init() {
      this.nowLevel = 0; //当前正在选择的职称级别
      this.chooseTitlesArr = [
        //当前选择的职称数组
        {
          id: null,
          name: "请选择"
        }
      ];
      this.titlesArr = {}; //职称数组
      this.nowIndex = null; //当前选择的下标
      this.titlesArrList = [{}, {}, {}]; //不同级别的职称数组
      this.indexList = [null, null, null]; //不同级别选择的职称下标
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      this.getData();
    },
    //获取职称三级联动信息
    getData() {
      if (this.allTitles === null) {
        selectParentList({})
          .then(res => {
            this.allTitles = res.data;
            this.titlesArr = res.data;
            this.titlesArrList[0] = res.data;
            if (
              this.titlesId !== undefined &&
              this.titlesId !== null &&
              this.titlesId !== ""
            ) {
              this.chooseTitlesFn();
            }
          })
          .catch(res => {
            return;
          });
      } else {
        this.titlesArr = JSON.parse(JSON.stringify(this.allTitles));
        this.titlesArrList[0] = JSON.parse(JSON.stringify(this.allTitles));
        if (
          this.titlesId !== undefined &&
          this.titlesId !== null &&
          this.titlesId !== ""
        ) {
          this.chooseTitlesFn();
        }
      }
    },
    //自动选择职称
    chooseTitlesFn() {
      let isTrue = false;
      let fn = (data, lev) => {
        for (let i = 0; i < data.length; i++) {
          if (isTrue) {
            return;
          }
          this.indexList[lev] = i;
          this.chooseTitlesArr[lev] = {
            id: data[i].id,
            name: data[i].name
          };
          this.titlesArr = data;
          this.titlesArrList[lev] = data;
          if (data[i].city && data[i].city.length > 0) {
            fn(data[i].city, 1);
          } else if (data[i].area && data[i].area.length > 0) {
            fn(data[i].area, 2);
          } else {
            if (this.titlesId == data[i].id) {
              this.nowIndex = i;
              this.nowLevel = lev;
              isTrue = true;
              return;
            }
          }
        }
      };
      fn(this.allTitles, 0);
      if (!isTrue) {
        this.nowLevel = 0; //当前正在选择的职称级别
        this.chooseTitlesArr = [
          //当前选择的职称数组
          {
            id: null,
            name: "请选择"
          }
        ];
        this.titlesArr = this.allTitles; //职称数组
        this.nowIndex = null; //当前选择的下标
        this.titlesArrList = [{}, {}, {}]; //不同级别的职称数组
        this.indexList = [null, null, null]; //不同级别选择的职称下标
      }
    },
    //选择职称
    chooseFn(id, name, children, index) {
      children ? (this.titlesArr = children) : "";
      this.nowIndex = null;
      this.indexList[this.nowLevel] = index;
      this.chooseTitlesArr[this.nowLevel] = {
        id: id,
        name: name
      };
      this.$emit("titlesBack", this.nowLevel, id, name);
      switch (this.nowLevel) {
        case 0:
          this.chooseTitlesArr[1] = {
            id: null,
            name: "请选择"
          };
          this.chooseTitlesArr.splice(2);
          this.indexList[1] = null;
          this.indexList[2] = null;
          this.nowLevel = 1;
          break;

        case 1:
          this.chooseTitlesArr[2] = {
            id: null,
            name: "请选择"
          };
          this.indexList[2] = null;
          this.nowLevel = 2;
          break;

        case 2:
          document.getElementsByTagName("html")[0].style.overflow = "visible";
          this.nowIndex = index;
          break;
        default:
          break;
      }
      children ? (this.titlesArrList[this.nowLevel] = children) : "";
    },
    //返回到某一级的职称选择
    backFn(i) {
      this.nowLevel = i;
      this.nowIndex = this.indexList[i];
      this.titlesArr = this.titlesArrList[i];
    },
    //关闭回调
    closeFn() {
      document.getElementsByTagName("html")[0].style.overflow = "visible";
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/common-titles.vue